var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"text":_vm.selectedCompanyName}},_vm._l((_vm.companies),function(company){return _c('b-dropdown-item',{key:company.id,on:{"click":function($event){return _vm.companySelected(company)}}},[_vm._v(_vm._s(company.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }